// hooks/useAtualizarDados.ts
import { useState } from "react";
// --------------------- Import Services ---------------------
import { atualizarCota } from "../services/atualizarCota";
import { atualizarCotaUsuario } from "../services/atualizarCotaUsuarioService";
import { buscarPeriodosByCotaUsuario } from "../../../services/buscarPeriodosByCotaUsuarioService";
// --------------------- Import Interface ---------------------
import { Cota } from "../interfaces/Cota";
import { CotaUsuario } from "../interfaces/CotaUsuario";

export const useAtualizarDadosConfiguracaoPropriedade = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [warning, setWarning] = useState<string | null>(null);
  const resetError = () => setError(null);
  const resetWarning = () => setWarning(null);

  const atualizarDadosConfiguracaoPropriedade = async (
    cotaId: number | undefined,
    cota: Cota,
    cotaUsuarioId: number | undefined | null,
    prioridade: CotaUsuario
  ) => {
    setIsLoading(true);
    setError(null);
    setWarning(null);
    setIsSuccess(false);

    try {
      // if (prioridade.cotaId != null && prioridade.cotaId !== cotaId) {
      //   const verificarCota = await buscarPeriodosByCotaUsuario(cotaUsuarioId);

      //   if (verificarCota) {
      //     setWarning(
      //       "Esta cota possui períodos vinculados a um usuário. Consulte o administrador para alterá-la."
      //     );
      //     return;
      //   }
      // }

      // Atualiza os dados caso não haja bloqueios
      const [cotas, prioridades] = await Promise.all([
        atualizarCota(cotaId, cota),
        atualizarCotaUsuario(cotaUsuarioId, prioridade),
      ]);

      if (cotas && prioridades) {
        setSuccess("Os dados foram atualizados!");
      } else {
        setError("Não foi possível atualizar os dados!");
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    atualizarDadosConfiguracaoPropriedade,
    isLoading,
    isSuccess,
    error,
    success,
    warning,
    resetError,
    resetWarning,
  };
};
